import React from 'react';
import { Card, CardHeader } from '../Bootstrap';
import { NoDataAvailable } from '../NoDataAvailable';
import './BigNumber.scss';

export class BigNumber extends React.Component<any, any> {
  render() {
    let content;

    if (this.props.data) {
      content = <p className='big-number'>{this.props.data}</p>;
    } else {
      content = <NoDataAvailable />;
    }

    return (
      <Card className={`card-bottom-margin ${this.props.className}`}>
        <CardHeader>{this.props.title}</CardHeader>
        <div className='big-number-wrapper'>{content}</div>
      </Card>
    );
  }
}
